import { motion } from "framer-motion";
import MainNav from "@/components/MainNav";
import { FaEnvelope } from "react-icons/fa";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="contact-page">
      <MainNav />

      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <h1 className="text-3xl md:text-4xl font-syne font-bold text-white mb-8" data-testid="contact-title">Contact</h1>
            
            <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-8 md:p-12 max-w-md mx-auto">
              <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-zinc-800 flex items-center justify-center">
                <FaEnvelope className="w-6 h-6 text-zinc-400" />
              </div>
              
              <p className="text-zinc-400 mb-6">
                Get in touch with us
              </p>
              
              <a
                href="mailto:hello@underplay.co.uk"
                className="flex items-center justify-center gap-2 px-6 py-3 bg-zinc-800 text-white rounded-full font-medium hover:bg-zinc-700 transition-colors"
                data-testid="email-link-hello"
              >
                <FaEnvelope />
                hello@underplay.co.uk
              </a>
            </div>
          </motion.div>

          {/* Logo */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="text-center mt-16"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_music-connect-23/artifacts/mbsj96z9_UNDERPLAY%20MUSIC%20LOGO%20NEW%202025%20no%20border%20no%20TEXT.png" 
              alt="Underplay" 
              className="h-16 w-auto mx-auto opacity-50"
            />
          </motion.div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-zinc-800 py-6">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p className="text-zinc-600 text-xs">© 2025 Underplay. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
